import React from "react";
import { Link } from "react-router-dom";
import { CustomButton, Icon, Logo } from "../../components";
import "./Footer.sass";

export const Footer = () => {
  return (
    <footer className="footer footer_desktop">
      <div className="footer__container footer__container_desktop desktop">
        <section className="footer__left footer__left_desktop">
          <Logo />
          <p>© 1991 - 2023 ЗАО «ТК ДАЗЭЛ»</p>
          <p>Политика конфиденциальности</p>
        </section>
        <div className="footer__blank" />
        <section className="footer__center desktop">
          <ul>
            <li>Оплата и доставка</li>
            <li>Юридическим лицам</li>
            <a href="https://company.dazel.ru/" target="_blank"> <li>Группа Компаний Дазэл</li></a>

          </ul>
          <ul>
            <li>Статьи</li>
            <li>О проекте</li>
          </ul>
        </section>
        <section className="footer__right_desktop">
          <CustomButton
            variant="orange"
            className="footer__button footer__button_desktop"
          >
            <Icon variant="mark" />
            Продавайте на Dazel
          </CustomButton>
          <div className="footer__icons">
            <Icon variant="inst" />
            <Icon variant="vk" />
          </div>
        </section>
      </div>
      <div className="footer__container_mobile footer__container mobile">
        <div className="footer__top footer__top_mobile">
          <ul>
            <li>Оплата и доставка</li>
            <li>Юридическим лицам</li>
            <li>Группа Компаний Дазэл</li>
            <li>Статьи</li>
            <li>О проекте</li>
          </ul>
          <div className="footer__icons">
            <Icon variant="inst" />
            <Icon variant="vk" />
          </div>
        </div>
        <CustomButton
          variant="orange"
          className="footer__button footer__button_mobile"
        >
          <Icon variant="mark" />
          Продавайте на Dazel
        </CustomButton>
        <p className="footer__copyright">
          © 1991 - 2022 ООО «Дазэл» <br />
          Торгово-технический центр
        </p>
      </div>
    </footer>
  );
};
